// @ts-check
import { WHATSAPP_CAMPAIGN_STATUS as C, formatShortDateTime, statusLabel } from '../../utils/whatsapp';

const STYLES = {
  [C.DRAFT]:
    'bg-amber-50 dark:bg-amber-950/50 text-amber-800 dark:text-amber-300 border-amber-200 dark:border-amber-900',
  [C.SCHEDULED]:
    'bg-purple-50 dark:bg-purple-950/50 text-purple-800 dark:text-purple-300 border-purple-200 dark:border-purple-900',
  [C.SENDING]: 'bg-blue-50 dark:bg-blue-950/50 text-blue-800 dark:text-blue-300 border-blue-200 dark:border-blue-900',
  [C.COMPLETED]:
    'bg-green-50 dark:bg-green-950/50 text-green-800 dark:text-green-300 border-green-200 dark:border-green-900',
  [C.CANCELLED]: 'bg-muted text-muted-foreground border-border',
};

const PAUSED_STYLE =
  'bg-orange-50 dark:bg-orange-950/50 text-orange-800 dark:text-orange-300 border-orange-200 dark:border-orange-900';

/**
 * Campaign state pill. A draft was created by the wizard but never sent, so it says so. A
 * scheduled campaign shows the local time it will go out, when the caller has it, so the admin
 * can confirm they picked the right date/time/timezone without opening the campaign. A `sending`
 * campaign the dispatcher auto-paused (pausedReason set) shows "Paused", not "Sending" - its
 * underlying status never actually leaves `sending` while paused.
 * @param {{status: string, scheduledAt?: string | null, pausedReason?: string | null}} props
 */
const CampaignStatusBadge = ({ status, scheduledAt, pausedReason }) => {
  if (pausedReason) {
    return (
      <span
        className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded-full whitespace-nowrap ${PAUSED_STYLE}`}
      >
        Paused
      </span>
    );
  }
  const scheduledFor = status === C.SCHEDULED && scheduledAt ? formatShortDateTime(scheduledAt) : '';
  const label =
    status === C.DRAFT ? 'Draft - not sent' : scheduledFor ? `Scheduled for ${scheduledFor}` : statusLabel(status);
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded-full whitespace-nowrap ${
        STYLES[status] ?? STYLES[C.CANCELLED]
      }`}
    >
      {label}
    </span>
  );
};

export default CampaignStatusBadge;
